import { render, staticRenderFns } from "./assetsProvideIndex.vue?vue&type=template&id=1d1ace01&scoped=true&"
import script from "./assetsProvideIndex.vue?vue&type=script&lang=js&"
export * from "./assetsProvideIndex.vue?vue&type=script&lang=js&"
import style0 from "./assetsProvideIndex.vue?vue&type=style&index=0&id=1d1ace01&scoped=true&lang=css&"
import style1 from "./assetsProvideIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ace01",
  null
  
)

export default component.exports